import { render, staticRenderFns } from "./liuyan.vue?vue&type=template&id=64628a91&scoped=true"
import script from "./liuyan.vue?vue&type=script&lang=js"
export * from "./liuyan.vue?vue&type=script&lang=js"
import style0 from "./liuyan.vue?vue&type=style&index=0&id=64628a91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64628a91",
  null
  
)

export default component.exports